export default "__VITE_ASSET__DhG0gU5E__"